import React, { useState, useEffect } from "react";
import Skeleton from "react-loading-skeleton";
import _ from "lodash";

import service from "../../../../../utils/service";
import brand_colors from "../../../../../utils/colors";
import Handle403 from "../../../../../components/Handle403";

const ReactHighcharts = require("react-highcharts");

const CMM_Statistics = ({ series }) => {
  const [chartdata, setChartdate] = useState({ status: "loading", res: [] });

  useEffect(() => {
    trigger_API();
  }, []);

  const trigger_API = async () => {
    let API_URL = "v4/tickets/status_counts?type=day";
    let res = await service.get(API_URL);
    if (res.status === 403) {
      setChartdate({
        status: "403",
        res: data,
      });
    }
    let data = _.get(res, "data.data");
    let meta = _.get(res, "data.meta");
    if (data && meta) {
      setChartdate({ status: "done", res: data });
    }
  };

  const getConfig = () => {
    if (!Array.isArray(chartdata.res)) return {};

    const newSeriesData = [];
    const wipSeriesData = [];
    const closedSeriesData = [];
    const escalationSeriesData = [];
    const formattedDate = [];

    chartdata.res.forEach((item) => {
      newSeriesData.push(item?.New ?? item?.new ?? 0);
      wipSeriesData.push(item?.wip ?? 0);
      closedSeriesData.push(item?.closed ?? 0);
      escalationSeriesData.push(item?.["review 1"] ?? 0);
      const d = new Date(item?.date);
      formattedDate.push(
        d.toLocaleDateString("en-US", { month: "short", day: "numeric" })
      );
    });

    return {
      chart: {
        type: "column",
        height: 250,
      },
      title: { text: "" },
      xAxis: {
        categories: formattedDate,
      },
      yAxis: {
        min: 0,
        title: { text: "Case Count" },
        stackLabels: {
          enabled: true,
          style: {
            fontWeight: "bold",
            color: "gray",
            textOutline: "none",
          },
        },
      },
      plotOptions: {
        column: {
          stacking: "normal",
          dataLabels: { enabled: true },
        },
      },
      series: [
        { name: "New", data: newSeriesData, color: brand_colors.new },
        { name: "WIP", data: wipSeriesData, color: brand_colors.wip },
        { name: "Closed", data: closedSeriesData, color: brand_colors.closed },
        { name: "ESCALATION", data: escalationSeriesData, color: brand_colors.escalation },
      ],
    };
  };


  const CmmStatistics = () => {
    switch (chartdata.status) {
      case "done":
        return <ReactHighcharts config={getConfig()} />;
      case "403":
        return <Handle403 />
      default:
        return <Skeleton count={5} />;
    }
  };

  return (
    <div className="card h-100 mb-3 p-0">
      <div className="card-body p-1 m-0">
        <div className="card-title p-2 m-0">CMM Statistics</div>
        {CmmStatistics()}
      </div>
    </div>
  );
};

export default CMM_Statistics;
